import { responsive, useTheme } from '@wci-tech/core-ui';
import { css } from '@emotion/react';
import { useMemo } from 'react';

export const useStyles = (isDark: boolean) => {
  const { theme } = useTheme();
  return useMemo(
    () => ({
      fieldContainer: css`
        position: relative;
        flex-shrink: 0;
        contain: layout;
        box-shadow: ${
          isDark
            ? `0 0 4px 0.5px rgba(64, 84, 209, 0.35),
        0 0 8px 2px rgba(64, 84, 209, 0.25)`
            : `0 0 4px 0.5px rgba(23, 206, 202, 0.35),
       0 0 8px 2px rgba(23, 206, 202, 0.25)`
        };
        border-radius: 16px;
        ${responsive.create({
          padding: {
            default: `${theme.spacing.get(24)} `,
            md: `${theme.spacing.get(32)} `,
            lg: `${theme.spacing.get(48)} `,
          },
          maxWidth: {
            default: `${theme.spacing.get(416)}`,
            md: `${theme.spacing.get(416)}`,
            lg: `${theme.spacing.get(584)}`,
          },
          marginTop: {
            default: `${theme.spacing.get(360)}`,
            md: `${theme.spacing.get(0)}`,
            lg: `${theme.spacing.get(0)}`,
          },
        })}
      `,
      fieldtitle: css`
        text-align: center;
        color: var(--text-color);
      `,

      addressText: css`
        color: var(--text-color);
        font-size: 16px;
        font-weight: 400;
        line-height: 1.4;
        max-width: 250px;
        ${responsive.create({
          fontSize: {
            default: `${theme.spacing.get(10)}`,
            md: `${theme.spacing.get(12)}`,
            lg: `${theme.spacing.get(16)}`,
          },
        })}
      `,

      iconLeft: css`
        ${responsive.create({
          marginRight: {
            default: `${theme.spacing.get(12)}`,
            md: `${theme.spacing.get(16)}`,
            lg: `${theme.spacing.get(24)}`,
          },
        })}
      `,

      infoOverlay: css`
        position: absolute;
        z-index: 2;
      `,

      iconBadge: css`
        background-color: ${theme.colors.commonColors.white};
        aspect-ratio: 1;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        ${responsive.create({
          height: {
            default: '30px',
            md: '36px',
            lg: '48px',
          },
        })}
      `,

      input: css`
        --tf-filled-bg-color: var(--tf-bg-muted-color);
        --tf-bg-color: var(--tf-bg-muted-color);
        --tf-active-color: var(--tf-text-color);
        --tf-border-color: var(--tf-border-color);
        --dropdown-active-color: var(--tf-text-color);

        color: var(--tf-text-color);
        width: 100%;
        display: block;
        position: relative;
        line-height: 1; // Important to put line-height otherwise textarea for message height get reduced.
        &:focus-within {
          --tf-border-color: var(--tf-active-color);
        }
      `,

      inputMessage: css`
        min-height: 112px;
      `,

      dropdown: css`
        --dropdown-border-color: ${
          isDark ? theme.colors.commonColors.white : theme.colors.commonColors.black
        };
        background-color: #fafafa;
      `,

      iconColor: css`
        --dropdown-active-color: var(--tf-text-color);
        --dropdown-clear-icon-active-color: var(--tf-text-color);
      `,

      toggleIcon: css`
        --dropdown-toggle-icon-color: var(--tf-text-color);
        --dropdown-toggle-icon-active-color: var(--tf-text-color);
      `,

      dropdownInput: css`
        --dropdown-input-border-color: var(--tf-border-color);
      `,
    }),
    [theme, isDark],
  );
};
